import { render, staticRenderFns } from "./TeacherProfileMini.vue?vue&type=template&id=d53d339e&scoped=true&"
import script from "./TeacherProfileMini.vue?vue&type=script&lang=js&"
export * from "./TeacherProfileMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53d339e",
  null
  
)

export default component.exports